<template>
  <div class="footer">人工服务热线：400-107-8586</div>
</template>

<script>
export default {
  name: "Footer"
}
</script>

<style scoped>
.footer {
  display: flex;
  justify-content: center;
  font-size: 12px;
  color: #616161;
  margin-bottom: 20px;
}
</style>